import React from "react";
import ReactDOM from "react-dom/client";
import { Agentation } from "agentation";
import "./index.css";
import App from "./App";

// Apply stored theme (dark or light) on initial load. If not set, respect user's preference.
const savedTheme = localStorage.getItem("theme");
if (savedTheme) {
  document.documentElement.setAttribute(
    "data-theme",
    savedTheme === "dark" ? "dark" : "light",
  );
} else if (
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
) {
  document.documentElement.setAttribute("data-theme", "dark");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "development") {
  const rootElement = document.getElementById("agentation-root");

  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <Agentation />
      </React.StrictMode>,
    );
  }
}
